var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.86428 13.455C1.00628 10.023 0.577277 8.308 1.47828 7.154C2.37928 6 4.14828 6 7.68528 6H12.3153C15.8533 6 17.6213 6 18.5223 7.154C19.4233 8.308 18.9943 10.024 18.1363 13.455C17.5903 15.638 17.3183 16.729 16.5043 17.365C15.6903 18 14.5653 18 12.3153 18H7.68528C5.43528 18 4.31028 18 3.49628 17.365C2.68228 16.729 2.40928 15.638 1.86428 13.455Z",
    stroke: "#E95A1A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.5 6.5L16.79 3.895C16.516 2.89 16.379 2.388 16.098 2.009C15.8178 1.63246 15.4373 1.3424 15 1.172C14.56 1 14.04 1 13 1M2.5 6.5L3.21 3.895C3.484 2.89 3.621 2.388 3.902 2.009C4.18218 1.63246 4.56269 1.3424 5 1.172C5.44 1 5.96 1 7 1",
    stroke: "#E95A1A",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 1C7 0.734784 7.10536 0.48043 7.29289 0.292893C7.48043 0.105357 7.73478 0 8 0H12C12.2652 0 12.5196 0.105357 12.7071 0.292893C12.8946 0.48043 13 0.734784 13 1C13 1.26522 12.8946 1.51957 12.7071 1.70711C12.5196 1.89464 12.2652 2 12 2H8C7.73478 2 7.48043 1.89464 7.29289 1.70711C7.10536 1.51957 7 1.26522 7 1Z",
    stroke: "#E95A1A",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup0);
export default __webpack_public_path__ + "static/media/group0.5591110a2ae65a44f699a917a8cdad5e.svg";
export { ForwardRef as ReactComponent };